export const enum ERoles {
    Admin = "admin",
    ClubsAdmin = "clubs-admin",
    Student = "user",
    University = "uni-admin",
    ClubsUniAdmin = "clubs-uni-admin",
    Guest = "guest",
}

export const enum EEvents {
    closeDropdown = "CLOSE_DROPDOWN",
}

export const enum EModals {
    Modality = "Modality",
    EditService = "EditService",
    EditRoom = "EditRoom",
    OverlayedGallery = "OverlayedGallery",
    CreateEvent = "CreateEvent",
    CreateLab = "CreateLab",
    CreateClub = "CreateClub",
    CreateQuestionnaire = "CreateQuestionnaire",
    Map = "Map",
    Starred = "Starred",
    CreateFeedback = "CreateFeedback",
    ProfileIncomplete = "ProfileIncomplete",
}

export const enum EForms {
    login = "LOGIN",
    signUpUni = `SIGN_UP_UNI`,
    signUpStudent = `SIGN_UP_STUDENT`,
    uniProfileInfo = `UNI_AFTER_SIGN_UP`,
    studentProfileInfo = `STUDENT_PROFILE`,
    dormitoryInfo = `DORMITORY_INFO`,
    editService = `EDIT_SERVICE`,
    editRoom = `EDIT_ROOM`,
    searchFilters = `SEARCH_FILTERS`,
    editBooking = `EDIT_BOOKING`,
    editEvent = `EDIT_EVENT`,
    editLab = `EDIT_LAB`,
    editClub = `EDIT_CLUB`,
    editQuestionnaire = `EDIT_QUESTIONNAIRE`,
    editEventBooking = `EDIT_EVENT_BOOKING`,
    universitiesSearch = `UNIVERSITIES_SEARCH`,
    clubsSearch = `CLUBS_SEARCH`,
    newsArticle = `NEWS_ARTICLE`,
    blogPost = 'NEW_BLOG_POST',

    createFeedback = `CREATE_FEEDBACK`,
}

export enum ESteps {
    MainInfo = "main-info",
    Rooms = "rooms",
    Services = "services",
    Rules = "rules",
    Documents = "documents",
}

export enum EEventTypes {
    Program = `program`,
    Service = `service`,
    Event = `event`,
}

export enum ERequestStatus {
    New = "new",
    Approved = "approved",
    Rejected = "rejected",
    Review = "review",
    Canceled = "canceled",
    DoneVisited = "done_visited",
    DoneNotVisited = "done_not_visited",
}
